<template>
  <div class="signup_container">
    <div class="account_row">
      <div class="account_title">
        Create your account
      </div>
    </div>    
    <form class="signup_form_box"> 
      <div class="row_1">
        <div class="form-group">
          <label>Full Name</label>
          <input v-model=formData.name v-validate="'required|alpha_spaces'" name="name" class="form-control" placeholder="Enter your Full Name">
        <span>{{ errors.first('name') }}</span>
        </div>
        <div class="form-group">
          <label>Email Address</label>
          <input v-validate="'required|email'" v-model=formData.email type="email" class="form-control" id="email" name="email" placeholder="Enter your Email Address">
          <span>{{ errors.first('email') }}</span>
        </div>
      </div>
      <div class="row_1">
        <div class="form-group">
          <label>Phone Number</label>
          <input v-model=formData.phone  v-validate="'required'" type=number class="form-control" name="phone number" placeholder="Enter phone number">
          <span>{{ errors.first('phone number') }}</span>
        </div>
        <div class="form-group">
          <label >Address</label>
          <input v-model=formData.address type="text" class="form-control" id="address"  placeholder="Enter your Address">
        </div>
      </div>
      <div class="radio_birth_row">
        <div class="row_radio">
          <div class="gender_text">
            <label>Select Gender</label>
          </div>
          <div class="radio">
            <label class="radio-inline"><input type="radio" name="male">Male</label>
            <label class="radio-inline"><input type="radio" name="female">Female</label>
          </div>
        </div>
        <div class="form-group">
          <label for="start">Date of Birth</label>
          <input v-model=formData.dob type="date" id="start" class="form-control" name="dob" required>
        </div>  
      </div>
      <div class="row_1">
        <div class="form-group">
          <label for="pwd">Password</label>
          <input v-model=formData.password v-validate="'required|min:6'" name="password" type="password" ref="password" class="form-control" placeholder="Enter Password">
          <span>{{ errors.first('password') }}</span>
        </div>
        <div class="form-group">
          <label for="pwd">Confirm Password</label>
          <input v-validate="'required|confirmed:password'" name="password_confirmation" type="password" class="form-control" data-vv-as="password" placeholder="Confirm Password">
          <span> {{ errors.first('password_confirmation') }}</span>
        </div>
      </div>
      <div class="row_btn">
        <div class="btn_container">
          <button class="btn_submit" @click.prevent=createAccount>SIGN UP</button>
        </div>
        <div class="signup_row">
          <span>Already have an account? Please <a @click="$router.push('/login')">LOGIN</a> here</span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
   data () {
      return {
        formData: {}
        }
    },
    methods: {
      createAccount(){
        this.$validator.validate().then(async result => {
          if(result){
           await this.$store.dispatch('registerApplicant', this.formData);

          }
        });
      }
    },
    mounted(){
      document.title = 'Sign Up - Consultancy Finder';
    }
}
</script>




// WEBPACK FOOTER //
// src/pages/Signup.vue